<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-bind:to="{ 'name': $i18n.locale + 'Settings' }">
            {{ $t('settings') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-bind:to="{ name: $i18n.locale + 'ListPaymentMethods', params: { property: property.slug } }">
            {{ $t('paymentMethods') }}
          </router-link>
        </li>
        <li class="breadcrumb-item" v-if="$route.params.priceId" aria-current="page">
          {{ $t('edit') }}
        </li>
        <li class="breadcrumb-item active" aria-current="page" v-else>
          {{ $t('create') }}
        </li>
      </ol>
    </nav>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">{{ $t('paymentMethod') }}</h1>
          <p class="lead text-muted">
            <span v-if="$route.params.method">{{$route.params.method}}</span>
            <span v-else>{{ $t('create') }}</span>
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-6 border-right">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
              <form id="paymentForm">

                <h5>{{ $t('information') }}</h5>

                <div class="form-group">
                  <label for="method.title">{{ $t('title') }}</label>
                  <ValidationProvider name="title" vid="method.title" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="method.title" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label for="method.description">{{ $t('description') }}</label>
                  <ValidationProvider name="description" vid="description" rules="required" v-slot="{ errors }">
                    <textarea rows="5" class="form-control" v-model="method.description" :class="{ 'is-invalid': errors[0] }"></textarea>
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group">
                  <label for="method.konto">{{ $t('konto') }}</label>
                  <ValidationProvider name="konto" vid="konto" rules="required" v-slot="{ errors }">
                    <input class="form-control" v-model="method.konto" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{errors[0]}}</span>
                  </ValidationProvider>
                </div>

                <div class="d-flex w-100">

                  <div class="btn-group btn-group-justified d-flex w-100 pb-5 pt-4">
                    <button type="button" name="cancel" class="btn btn-danger flex-grow-1" v-bind:class="{'disabled': !method._id}" @click="deleteMethod()">{{ $t('delete') }}</button>
                    <button type="button" name="save" class="btn btn-primary flex-grow-1" @click="handleSubmit(submit)">{{ $t('save') }}</button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const timestamp = Date.now();

export default {
  name: 'CreatePaymentMethod',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name){
        vm.from = from.fullPath
      }else{
        vm.from = null
      }
    });
  },
  data: () => ({
    from: null,
    api: {
      url: '/payment-methods',
      method: 'post'
    },
    property: {
      rooms: []
    },
    method: {
      property: {}
    },
  }),
  created(){

    if(this.$route.params.method){
      this.api.url = '/payment-methods/' + this.$route.params.method;
      this.api.method = 'put'
      fetch(process.env.VUE_APP_API + this.api.url, {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        this.method = response;
        this.property = this.$store.state.host.properties.find(p => p._id == this.method.property._id);
      })
    }else{
      this.property = this.$store.state.host.properties.find(p => p.slug == this.$route.params.property);
      this.method.property._id = this.property._id;
    }
  },
  methods: {
    submit: function(){
      return fetch( process.env.VUE_APP_API + this.api.url, {
        method : this.api.method,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify(this.method)
      })
      .then(response => response.json())
      .then(response => {
        console.log(response);
        if(!response.error){
          if(this.from){
            this.$router.push(this.from);
          }else{
            this.$router.push({name: this.$i18n.locale + 'ListPaymentMethods', params: { property: this.property.slug }});
          }
        }else{
          console.log(response.error);
          this.$refs.form.setErrors(response.error.messages);
        }
      });
    },
    deleteMethod: function(){
      if(!confirm("Are you sure you want to delete payment method?")) return;
      return fetch(process.env.VUE_APP_API + '/payment-methods/' + this.$route.params.method, {
        method: 'delete',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          this.$parent.messages.push({
            type: "alert",
            status: 'success',
            message: 'Payment Method Deleted Successfully',
            time: timestamp
          })
          if(this.from){
            this.$router.push(this.from);
          }else{
            this.$router.push({name: this.$i18n.locale + 'ListPaymentMethods', params: { property: this.property.slug }});
          }
        }else{
          this.$parent.messages.push({
            type: "alert",
            status: 'danger',
            message: response.error,
            time: timestamp
          })
        }
      })
    }
  },
}
</script>

<i18n>
{
  "en": {
    "settings": "Settings",
    "paymentMethods": "Payment Methods",
    "paymentMethod": "Payment Method",
    "create": "Create Payment Method",
    "edit": "Edit Payment Method",
    "save": "Save Payment Method",
    "delete": "Delete Payment Method",
    "property": "Property",
    "information": "Payment Method Information",
    "title": "Title",
    "description": "Description",
    "konto": "Accounting code"
  },
  "sl": {
    "settings": "Nastavitve",
    "paymentMethods": "Plačilna sredstva",
    "paymentMethod": "Plačilno sredstvo",
    "create": "Ustvari plačilno sredstvo",
    "edit": "Uredi plačilno sredstvo",
    "save": "Shrani plačilno sredstvo",
    "delete": "Pobriši plačilno sredstvo",
    "property": "Nastanitev",
    "information": "Podatki plačilnega sredstva",
    "title": "Naziv",
    "description": "Opis",
    "konto": "Konto"
  }
}
</i18n>
